import React from 'react';
import { NavItemDef } from '../navItems';

export const LEXID_NAV_ITEMS: NavItemDef[] = [
  // Organization section
  {
    key: 'lexid.divider.organization',
    label: 'common.navItems.lexid.dividers.organization',
    divider: true,
    visibility: ({ hasPermission, hasAppPermission, currentOrganizationId }) =>
      hasPermission('getOrg', currentOrganizationId) ||
      hasPermission('listRoles', currentOrganizationId) ||
      hasPermission('listGroups', currentOrganizationId) ||
      hasPermission('editOrgSolution', currentOrganizationId) ||
      hasPermission('addRelatedOrg', currentOrganizationId) ||
      hasAppPermission('listOrgs'),
  },
  {
    key: 'organization.settings',
    label: 'common.navItems.lexid.myOrganization',
    subtitle: 'common.navItems.lexid.subtitles.myOrganization',
    path: 'settings',
    permissions: ['getOrg'],
  },
  {
    key: 'organization.roles',
    label: 'common.navItems.lexid.roles',
    subtitle: 'common.navItems.lexid.subtitles.roles',
    path: 'roles',
    permissions: ['listRoles'],
    nonRoot: true,
  },
  {
    key: 'organization.groups',
    label: 'common.navItems.lexid.groups',
    subtitle: 'common.navItems.lexid.subtitles.groups',
    path: 'groups',
    permissions: ['listGroups'],
    nonRoot: true,
  },
  {
    key: 'manage.solutions',
    label: 'common.navItems.lexid.solutions',
    subtitle: 'common.navItems.lexid.subtitles.solutions',
    path: 'manage-solutions',
    permissions: ['editOrgSolution'],
    nonRoot: true,
  },
  {
    key: 'organizations',
    label: 'common.navItems.lexid.organizations',
    subtitle: 'common.navItems.lexid.subtitles.organizations',
    path: 'organizations',
    appPermissions: ['listOrgs'],
    sameOrg: true,
  },
  {
    key: 'organization.riskPoolSharing',
    label: 'common.navItems.lexid.riskPoolSharing',
    subtitle: 'common.navItems.lexid.subtitles.riskPoolSharing',
    path: 'risk-pool-sharing',
    permissions: ['addRelatedOrg'],
    nonRoot: true,
    requiresRiskPool: true,
  },
  // Users section
  {
    key: 'lexid.divider.users',
    label: 'common.navItems.lexid.dividers.users',
    divider: true,
    nonRoot: true,
    visibility: ({ hasPermission, currentOrganizationId }) =>
      hasPermission('listUsers', currentOrganizationId) ||
      hasPermission('listJobsImportUsers', currentOrganizationId),
  },
  {
    key: 'organization.users',
    label: 'common.navItems.lexid.users',
    subtitle: 'common.navItems.lexid.subtitles.users',
    path: 'users',
    permissions: ['listUsers'],
    nonRoot: true,
  },
  {
    key: 'organization.user_imports',
    label: 'common.navItems.lexid.userImport',
    subtitle: 'common.navItems.lexid.subtitles.userImport',
    path: 'user-imports',
    permissions: ['listJobsImportUsers'],
    nonRoot: true,
  },
];
